module.exports = __webpack_public_path__ + "img/guide-table-icon.023dc1f5.svg";